import Layout from '@/layout'

function search(route) {
  return route.query
}

export const asyncRouter = [
  {
    name: 'index_support',
    path: '/index_support',
    hidden: true,
    meta: {},
    component: () => import('@/views/index_support')
  },
  {
    name: 'electricalSupervision',
    path: '/electricalSupervision',
    hidden: true,
    redirect: 'noRedirect',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '设备管理',
      icon: 'market',
      noCache: false,
      link: null
    },
    children: [
      {
        name: 'hostDetails',
        path: 'net/hostDetails',
        hidden: false,
        component: () => import('@/views/electricalSupervision/net/hostDetails'),
        props: search,
        meta: {
          title: '设备详情',
          icon: '#',
          backShow: true
        }
      },
      {
        name: 'hostDetails_shell',
        path: 'shell/hostDetails',
        hidden: false,
        component: () => import('@/views/electricalSupervision/shell/hostDetails'),
        meta: {
          title: '设备详情',
          icon: '#',
          backShow: true
        }
      },
      {
        name: 'hostDetails_threePhase',
        path: 'threePhase/hostDetails',
        hidden: false,
        component: () => import('@/views/electricalSupervision/threePhase/HostDetails'),
        meta: {
          title: '设备详情',
          icon: '#',
          backShow: true
        }
      },
      {
        path: '/electricalSupervision/socket/HostDetails',
        component: () => import('@/views/electricalSupervision/socket/HostDetails.vue'),
        name: 'hostDetails_socket',
        hidden: false,
        meta: { title: '设备详情', backShow: true }
      },
      {
        path: '/electricalSupervision/wallSwitch/HostDetails',
        component: () => import('@/views/electricalSupervision/wallSwitch/HostDetails.vue'),
        name: 'hostDetails_switch',
        hidden: false,
        meta: { title: '设备详情', backShow: true }
      },
      {
        path: '/electricalSupervision/aircondition/HostDetails',
        component: () => import('@/views/electricalSupervision/aircondition/HostDetails.vue'),
        name: 'hostDetails_air',
        hidden: false,
        meta: { title: '设备详情', backShow: true }
      },
      {
        path: '/electricalSupervision/temperature/HostDetails',
        component: () => import('@/views/electricalSupervision/temperature/HostDetails.vue'),
        name: 'hostDetails_temp',
        hidden: false,
        meta: { title: '设备详情', backShow: true }
      },
      {
        path: '/electricalSupervision/powerStrip/HostDetails',
        component: () => import('@/views/electricalSupervision/powerStrip/HostDetails.vue'),
        name: 'hostDetails_strip',
        hidden: false,
        meta: { title: '设备详情', backShow: true }
      },
      {
        path: '/electricalSupervision/smoking/HostDetails',
        component: () => import('@/views/electricalSupervision/smoking/HostDetails.vue'),
        name: 'hostDetails_smoking',
        hidden: false,
        meta: { title: '设备详情', backShow: true }
      },
      {
        path: '/electricalSupervision/net/enableSettings',
        component: () => import('@/views/electricalSupervision/net/enableSettings.vue'),
        name: 'enableSettings',
        hidden: false,
        meta: { title: '使能设置', backShow: true }
      },
      {
        path: '/electricalSupervision/shell/enableSettings',
        component: () => import('@/views/electricalSupervision/shell/enableSettings.vue'),
        name: 'enableSettingsSell',
        hidden: false,
        meta: { title: '使能设置', backShow: true }
      },
      {
        path: '/electricalSupervision/threePhase/enableSettings',
        component: () => import('@/views/electricalSupervision/threePhase/EnableSettings.vue'),
        name: 'enableSettingsThree',
        hidden: false,
        meta: { title: '使能设置', backShow: true }
      },
      {
        path: '/electricalSupervision/temperature/enableSettings',
        component: () => import('@/views/electricalSupervision/temperature/EnableSetting.vue'),
        name: 'enableSettingsTemp',
        hidden: false,
        meta: { title: '使能设置', backShow: true }
      }
    ]
  },
  {
    name: 'system',
    path: '/system',
    hidden: true,
    redirect: 'noRedirect',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '系统管理',
      icon: 'market',
      noCache: false,
      link: null
    },
    children: [
      {
        name: 'neutral',
        path: 'neutral',
        hidden: false,
        component: () => import('@/views/system/neutral'),
        meta: {
          title: '中性配置',
          icon: '#',
          noCache: false,
          link: null
        }
      },
      {
        name: 'accountChild',
        path: 'accountChild',
        hidden: false,
        component: () => import('@/views/system/account'),
        meta: {
          title: '子账户管理',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'accountHostDetails',
        path: 'account/hostDetails',
        hidden: false,
        component: () => import('@/views/system/account/hostDetails'),
        meta: {
          title: '账户详情',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'openPlatformHostDetails',
        path: 'openPlatform/hostDetails',
        hidden: false,
        component: () => import('@/views/system/openPlatform/hostDetails'),
        meta: {
          title: '应用管理',
          backShow: true,
          icon: '#'
        }
      }
    ]
  },
  {
    name: 'comprehensiveControl',
    path: '/comprehensiveControl',
    hidden: true,
    redirect: 'noRedirect',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '综合管控',
      icon: 'control',
      noCache: false,
      link: null
    },
    children: [
      {
        name: 'createTask',
        path: 'scheduledTask/createTask',
        hidden: true,
        component: () => import('@/views/comprehensiveControl/scheduledTask/createTask'),
        meta: {
          title: '新增定时任务',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'createTask_shell',
        path: 'scheduledTask/createTask_shell',
        hidden: true,
        component: () => import('@/views/comprehensiveControl/scheduledTask/createTask_shell'),
        meta: {
          title: '新增定时任务',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'createTask_relay',
        path: 'scheduledTask/createTask_relay',
        hidden: true,
        component: () => import('@/views/comprehensiveControl/scheduledTask/createTask_relay'),
        meta: {
          title: '新增定时任务',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'createTask_socket',
        path: 'scheduledTask/createTask_socket',
        hidden: true,
        component: () => import('@/views/comprehensiveControl/scheduledTask/socket/CreateTask_index'),
        meta: {
          title: '新增定时任务',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'createTask_switch',
        path: 'scheduledTask/createTask_switch',
        hidden: true,
        component: () => import('@/views/comprehensiveControl/scheduledTask/switch/CreateTask_index'),
        meta: {
          title: '新增定时任务',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'createLeak',
        path: 'leakageProtection/createLeak',
        hidden: true,
        component: () => import('@/views/comprehensiveControl/leakageProtection/createLeak'),
        meta: {
          title: '新增漏保自检',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'createTask_air',
        path: 'scheduledTask/createTask_air',
        hidden: true,
        component: () => import('@/views/comprehensiveControl/scheduledTask/createTask_air'),
        meta: {
          title: '新增定时任务',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'createTask_power',
        path: 'scheduledTask/createTask_power',
        hidden: true,
        component: () => import('@/views/comprehensiveControl/scheduledTask/createTask_power'),
        meta: {
          title: '新增定时任务',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'createScene',
        path: 'scene/createScene',
        hidden: true,
        component: () => import('@/views/comprehensiveControl/scene/createScene'),
        meta: {
          title: '新增场景',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'createRuntime',
        path: 'runtimeTense/createRuntime',
        hidden: true,
        component: () => import('@/views/comprehensiveControl/runtimeTense/createRuntime'),
        meta: {
          title: '运行时态监测配置',
          backShow: true,
          icon: '#'
        }
      }
    ]
  },
  {
    name: 'operationMaintenance',
    path: '/operationMaintenance',
    redirect: 'noRedirect',
    component: Layout,
    alwaysShow: true,
    hidden: true,
    meta: {
      title: '监控运维',
      icon: null,
      noCache: false,
      link: null
    },
    children: [
      {
        name: 'workOrder/workSetting',
        path: 'workOrder/workSetting',
        hidden: false,
        component: () => import('@/views/operationMaintenance/workOrder/workSetting'),
        meta: {
          title: '工单设置',
          backShow: true,
          icon: '#'
        }
      }
    ]
  },
  {
    name: 'operationMaintenance',
    path: '/operationMaintenance',
    redirect: 'noRedirect',
    component: Layout,
    alwaysShow: true,
    hidden: true,
    meta: {
      title: '维保计划',
      icon: null,
      noCache: false,
      link: null
    },
    children: [
      {
        name: 'maintenancePlan/addPlan',
        path: 'maintenancePlan/addPlan',
        hidden: false,
        component: () => import('@/views/operationMaintenance/maintenancePlan/addPlan'),
        meta: {
          title: '新增',
          backShow: true,
          icon: '#'
        }
      },
      {
        name: 'maintenancePlan/maintenanceTask',
        path: 'maintenancePlan/maintenanceTask',
        hidden: false,
        component: () => import('@/views/operationMaintenance/maintenancePlan/maintenanceTask'),
        meta: {
          title: '维保任务',
          backShow: true,
          icon: '#'
        }
      }
    ]
  }
]

export default asyncRouter
